import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink,
    Progress,
    Spinner,
    NavbarBrand
} from 'reactstrap';
import "./Test.css"

class CreateTest extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                    <Form className="boxTest1">
                        <h1 className="textTest">แบบทดสอบวัดระดับ</h1>
                        <br></br>   
                        
                        <p className="textLearn">ระดับง่าย (easy) <Spinner type="grow" color="warning" /></p>
                        <Form className="bt2-3">
                            <Button className="btTest2" href="https://forms.gle/uUyzN8RUakPY3jL79">แบบทดสอบ ชุดที่1</Button>
                            <Button className="btTest3" href="https://forms.gle/uUyzN8RUakPY3jL79">แบบทดสอบ ชุดที่2</Button>
                        </Form> 
                        <p className="textLearn">ระดับทั่วไป (normal) <Spinner type="grow" color="danger" /></p>
                        <Form className="bt4-7">
                            <Button className="btTest4" href="https://forms.gle/oHWjPZrkTouS3V98A">แบบทดสอบ ชุดที่1</Button>
                            <Button className="btTest5" href="https://forms.gle/9PYgrmVCZebWNn636">แบบทดสอบ ชุดที่2</Button>
                            <Button className="btTest6" href="https://forms.gle/3QRmtEwo8vcieQD4A">แบบทดสอบ ชุดที่3</Button>
                            <Button className="btTest7" href="https://forms.gle/tot246im8WMmNRJWA">แบบทดสอบ ชุดที่4</Button>
                        </Form>
                      <p className="textLearn">ระดับยาก (hard) <Spinner type="grow" color="danger" /></p>
                        <Form className="bt9-10">
                            <Button className="btTest8" href="https://forms.gle/Mz7kD5xZB6yw2TGN8">แบบทดสอบ ชุดที่1</Button>
                            <Button className="btTest9" href="https://forms.gle/cCJeiaRuJob9uoLC8">แบบทดสอบ ชุดที่2</Button>
                            <Button className="btTest10" href="https://forms.gle/cYg3BQ7xCJkwPYyq8">แบบทดสอบ ชุดที่3</Button>
                         </Form> 
                         <br></br>   
                         <br></br> 
                         <NavbarBrand href="/randomtest" className="brand-logo">
                         <span className="textrd"><h2 align='center' className="texttestch" >Challenge Testing</h2></span>
                          </NavbarBrand> 
                            <br></br>   
                           
                          
                    </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default CreateTest